module.exports = __webpack_public_path__ + "static/img/banner17.adbee130.png";